
    var riot = require('riot')
    //src: starling/src/tags/app-header.html
riot.tag2('app-header',
  '<a id="header-link" class="Button Button--Icon Button--Plain" href="{window.workspace ? `/workspace/${window.workspace.publicIdentifier}` : \'/\'}" data-tip="{LogoToolTip()}" data-tip-align="left" data-track="Navigate" data-track-action="Logo" riot-style="{window.pageSettings.embedded && \'pointer-events: none;\'}"> <svg if="{!window.workspace}" class="Button__Icon"> <use xlink:href="#plectica-logo"></use> </svg> <workspace-avatar if="{window.workspace}" workspace="{window.workspace}" size="small" style="margin: 0;"></workspace-avatar> </a> <span if="{!window.pageSettings.embedded}" class="app-header_divider"></span> <div if="{!window.pageSettings.embedded}" ref="titleWrapper" data-tip="{getTitle()}" class="app-header_title_container"> <h5 if="{!canvas.isViewOnly()}" ref="title" id="map-title-label" class="app-header_title {canvas.isViewOnly() && \'view-only\'}" contenteditable="true" onclick="{handleTitleClick}" onblur="{handleTitleBlur}" onkeydown="{handleTitleKeydown}" onpaste="{handlePaste}" spellcheck="{window.user && window.user.settings.spellcheck !== 0 ? \'true\' : \'false\'}">{getTitle()}</h5> <h5 if="{canvas.isViewOnly()}" ref="readonlytitle" id="map-title-label" class="app-header_title">{getTitle()}</h5> </div> <span if="{canvas.isViewOnly() && !canvas.canCommentOnly()}" class="app-header_badge">view only</span> <span if="{canvas.isFeatureEnabled(\'comments\') && canvas.canCommentOnly()}" class="app-header_badge">you can comment</span> <div if="{!window.pageSettings.hideMapMenu}" class="app-header_floating-menu_container hideWhenPresenting"> <button ref="mapMenuButton" class="Button Button--Icon Button--Plain" onclick="{toggleMapMenu}"> <svg class="Button__Icon"> <use xlink:href="#more-vert-icon"></use> </svg> </button> <map-menu ref="mapMenu" canvas="{canvas}"></map-menu> </div> <undo-redo if="{!canvas.isViewOnly()}" canvas="{canvas}"></undo-redo> <header-save-indicator canvas="{canvas}" origin="header"></header-save-indicator> <div style="flex: 1;"></div> <div if="{!this.isSubscriber() && window.user}" style="display: flex; align-items: center; margin-right: 24px;"> <a href="/pricing" class="app-header--node-count-progress" style="align-items: flex-start; flex-direction: column; margin-right: 8px;" data-tip="Upgrade to Plectica Pro for unlimited cards" data-tip-align="bottom"> <div class="progressbar"> <div id="node-count-progress" class="progressbar_fill"></div> </div> <span style="color: #8595a9; font-size: 12px; font-weight: 500; margin-top: 6px; white-space: normal;"> used <span id="node-count-progress-header-text"></span> cards of 250 </span> </a> <a href="/pricing" class="Button Button--Accent Button--Outlined ws-nowrap">Upgrade to Plectica Pro</a> </div> <button if="{!window.pageSettings.hideHelp}" class="Button Button--Plain Button--Header hideWhenPresenting" onclick="{toggleUserGuide}" data-tip="User Guide & Keyboard Shortcuts"> <svg class="Button__Icon"> <use xlink:href="#help-icon"></use> </svg> <span class="Button__Label"> Help </span> </button> <button if="{!canvas.zenMode}" class="Button Button--Plain Button--Icon mrgn-l-4 zen-mode_button" onclick="{toggleZenMode}" data-tip="Focus mode ({shortcut})"> <svg class="Button__Icon"> <use xlink:href="#fullscreen-icon"></use> </svg> </button> <notifications if="{window.user && !window.pageSettings.disableWebsocket && canvas.isFeatureEnabled(\'recent_activity\')}" canvas="{canvas}"></notifications> <button if="{canvas.isFeatureEnabled(\'comments\')}" class="Button Button--Plain {getCommentCount() ? \'Button--Header\' : \'Button--Icon\'} mrgn-l-4 hideWhenPresenting" data-tip="Show comments" onclick="{toggleCommentLayer}"> <span class="Button__Icon"> <svg class="Button__Icon"> <use xlink:href="#comment-text-outline-icon"></use> </svg> <span if="{hasUnseenComments()}" class="notifications_alert">*</span> </span> <span if="{getCommentCount()}" class="Button__Label"> {getCommentCount()} </span> </button> <div if="{!window.pageSettings.embedded && window.user}" id="share-button-container" class="mrgn-l-8 hideWhenPresenting" style="position: relative;"> <button ref="shareButton" class="share-button Button Button--Primary Button--Small" onclick="{showShareModal}" data-tip="Share map"> Share </button> <popover ref="sharePopover" size="small" type="knockout" position="below"> <p>Invite collaborators to work in real-time or share your creation with others!</p> <button class="Button Button--Small Button--Primary" style="float: right; margin-top: 16px;" onclick="{parent.showShareModal}"> Share your map </button> </popover> <popover if="{false}" ref="accessPopover" title="Request for access" size="small" position="below" visible="{true}"> <p>3 people have requested access to this map.</p> <button class="Button Button--Small Button--Secondary Button--Link" style="float: right;"> View requests </button> </popover> </div> <presence if="{!window.pageSettings.disableWebsocket}" canvas="{canvas}" operation="{operation}"></presence> <modal-search canvas="{canvas}"></modal-search> <span class="app-header_divider hideWhenPresenting"></span> <div ref="userAccount"></div>',
  '',
  'hide="{pageSettings.hideMapHeader}" class="app-header"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _util = require('lib/util');

var _escapeHtml = require('escape-html');

var _escapeHtml2 = _interopRequireDefault(_escapeHtml);

var _util2 = require('lib/util.js');

var _searchUi = require('lib/search-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

var _commentsUi = require('lib/comments-ui');

var _upsellUi = require('lib/upsell-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.title = store.title;
this.store = opts.store;
this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.appHeaderTag = this;
this.isOpen = false;
this.commentLayerOn = false;
var self = this;
var isMac = this.canvas.isMac;

this.shortcut = isMac ? '⇧⌘F' : 'Ctrl+Shift+F';

this.isSubscriber = function () {
  return _upsellUi.usui.isSubscriber();
};

this.closeMapMenu = function () {
  var _refs = _this.refs,
      mapMenu = _refs.mapMenu,
      mapMenuButton = _refs.mapMenuButton;

  if (!_this.isOpen) {
    return;
  }

  mapMenu.hide();
  mapMenuButton.classList.remove('floating-menu_button--active');
  _this.isOpen = false;
};

this.openMapMenu = function () {
  var _refs2 = _this.refs,
      mapMenu = _refs2.mapMenu,
      mapMenuButton = _refs2.mapMenuButton;

  if (_this.isOpen) {
    return;
  }

  mapMenu.summon();
  mapMenuButton.classList.add('floating-menu_button--active');
  _this.isOpen = true;
};

this.toggleMapMenu = function () {
  var isOpen = _this.isOpen;

  _this.canvas.hidePopups();

  if (!isOpen) {
    _eventTracking2.default.track({
      category: 'Map-Header',
      action: 'Map-Menu-Open',
      label: 'Map-Menu-Toggle-Open'
    });
    _this.openMapMenu();
  }
};

this.getTitle = function () {
  return (0, _util2.decodeHtml)(_this.store.getTitle());
};

this.saveTitle = function () {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  var title = $('#map-title-label').text();
  _this.refs.title.scrollLeft = 0;

  if (!title && !title.length) {
    title = _constants.DEFAULTS.MAP_TITLE;
    $(_this.refs.title).text(title);
  }
  var prevTitle = _this.store.getTitle();
  _this.refs.titleWrapper.setAttribute('data-tip', title.trim());

  if (prevTitle == title) {
    // ignore if no change
    return;
  }
  title = title.trim();
  $(_this.refs.title).text(title);
  _this.store.setTitle(title);
  _this.operation.setMapTitle({ title: title, prevTitle: prevTitle }, function (e) {
    console.log('setMapTitle error: ' + e);
  });
  document.title = title + ' - Plectica';
};

this.revertTitle = function (e) {
  var title = _this.store.getTitle();
  e.target.innerText = title;
};

this.on('mount', function () {
  var title = _this.refs.title;

  var titleText = _this.store.getTitle();
  var needsSave = false;

  $(_this.refs.userAccount).replaceWith($('.user-account'));

  if (_this.isFirstMap() && !_this.canvas.isViewOnly() && titleText == _constants.DEFAULTS.MAP_TITLE) {
    titleText = 'My First Map';
    needsSave = true;
  }
  if (title) {
    title.innerHTML = titleText;
  }
  if (_this.refs.readonlytitle) {
    _this.refs.readonlytitle.innerHTML = titleText;
  }
  if (needsSave) {
    window.setTimeout(_this.saveTitle, 500);
  }

  _this.operation.on('operation-set-map-title', function () {
    document.title = (0, _util2.decodeHtml)(_this.store.getTitle()) + ' - Plectica';
    title.innerHTML = _this.store.getTitle();
    if (_this.refs.title) _this.refs.title.innerHTML = _this.store.getTitle();
    if (_this.refs.readonlytitle) _this.refs.readonlytitle.innerHTML = _this.store.getTitle();
  });

  _this.operation.on('operation-update-map-share-settings', function () {
    _this.update();
  });

  _searchUi.searchUI.searchKeyOverride(_this.refs.title);

  setInterval(_this.callOutCollaboration, 5 * 60 * 1000);
  _upsellUi.usui.updateNodeCount();
});

this.handleTitleClick = function (e) {
  _this.refs.titleWrapper.removeAttribute('data-tip');
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.refs.title.focus();
};

this.handleTitleBlur = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  _this.saveTitle();
};

this.handleTitleKeydown = function (e) {
  if (_this.canvas.isViewOnly()) {
    return;
  }
  var ENTER = _constants.KEY_CODES.ENTER,
      TAB = _constants.KEY_CODES.TAB,
      ESCAPE = _constants.KEY_CODES.ESCAPE;

  if ([ESCAPE].indexOf(e.keyCode) !== -1) {
    e.preventDefault();
    _this.revertTitle(e);
    _this.refs.title.blur();
  } else if ([ENTER, TAB].indexOf(e.keyCode) !== -1) {
    e.preventDefault();
    _this.saveTitle();
    _this.refs.title.blur();
  }
};

this.isFirstMap = function () {
  return Boolean(window.user && window.user.should_show_intro);
};

this.setDidAddNode = function () {
  _this.didAddNode = true;
};

this.toggleZenMode = function (e) {
  canvas.toggleZenMode();
};

this.callOutCollaboration = function () {
  var _window = window,
      map_collaborators = _window.map_collaborators,
      intercomSettings = _window.intercomSettings;

  var shareContainer = document.getElementById('share-button-container');
  var shareButtonVisible = shareContainer ? shareContainer.getBoundingClientRect().bottom > 0 : false;

  var howLongAgo = 3 * 24 * 60 * 60 * 1000; // three days
  var lastDismissed = parseInt(localStorage.getItem('collaborationCallOutDismissed'), 10);

  if (intercomSettings && intercomSettings.collaborators_last_28_days > 0) {
    return;
  }

  if (new Date() - lastDismissed < howLongAgo) {
    return;
  }

  if ((!map_collaborators || map_collaborators.length <= 1) && store.getNodesSize() > 20 && shareButtonVisible) {
    _this.showCollaborationQuote();
  }
};

this.showCollaborationQuote = function () {
  var _refs3 = _this.refs,
      shareButton = _refs3.shareButton,
      sharePopover = _refs3.sharePopover;

  var quote = _constants.COLLABORATION_QUOTES[Math.floor(Math.random() * _constants.COLLABORATION_QUOTES.length)];

  if (!sharePopover.hidden) return;

  shareButton.removeAttribute('data-tip');
  shareButton.classList.add('Button--Pulsing');

  if (quote.author) {
    sharePopover.setTitle(quote.quote + ' <nobr>\u2013 ' + quote.author + '</nobr>');
  } else {
    sharePopover.setTitle(quote.quote);
  }

  sharePopover.on('close', function () {
    _eventTracking2.default.track({
      category: 'Map-Header',
      action: 'Share-Popover-Dismissed',
      label: 'Share-Popover-Dismissed'
    });

    _this.resetShareButton();
  });

  sharePopover.show();

  _eventTracking2.default.track({
    category: 'Map-Header',
    action: 'Share-Popover-Shown',
    label: 'Share-Popover-Shown'
  });
};

this.resetShareButton = function () {
  var shareButton = _this.refs.shareButton;

  shareButton.classList.remove('Button--Pulsing');
  setTimeout(function () {
    return shareButton.setAttribute('data-tip', 'Share map');
  }, 400);
  localStorage.setItem('collaborationCallOutDismissed', new Date().getTime());
};

this.showShareModal = function () {
  _this.openShareModal();
  _eventTracking2.default.track({
    category: 'Map-Header',
    action: 'Share-Modal-Shown',
    label: 'Share-Modal-Shown'
  });
};

this.openShareModal = function () {
  _this.canvas.shareModal.show();
  _this.refs.sharePopover.close();
  _this.resetShareButton();
};

this.saveMap = function (e) {
  var dumped = store.dump();
  delete dumped.deleted;
  if (window !== window.parent) {
    window.parent.localStorage.setItem('embeddedStore', JSON.stringify(dumped));
    window.parent.location = '/maps/import-embedded';
  } else {
    window.localStorage.setItem('embeddedStore', JSON.stringify(dumped));
    window.location = '/maps/import-embedded';
  }
};

this.toggleUserGuide = function () {
  if (_this.canvas.sidebarStatus !== 'user-guide') {
    _this.canvas.openSidebar('user-guide');
  } else {
    _this.canvas.closeSidebar();
  }
};

this.toggleCommentLayer = function () {
  _commentsUi.commentsUI.toggleCommentLayer();
  _this.update();
};

this.getCommentCount = function () {
  return _this.canvas.store.totalCommentCount();
};

this.hasUnseenComments = function () {
  return _commentsUi.commentsUI.hasUnseenComments();
};

this.handlePaste = function (e) {
  e.preventDefault();
  if (_this.canvas.isViewOnly()) return;
  var text = (0, _util.convertNewlines)((0, _escapeHtml2.default)(e.clipboardData.getData("text/plain")));
  document.execCommand("insertHTML", false, text);
};

this.LogoToolTip = function () {
  if (window.workspace) {
    var workspaceName = window.workspace.name;
    if (workspaceName.length > 50) {
      workspaceName = workspaceName.substr(0, 50) + '...';
    }
    return 'Back to ' + workspaceName;
  }
  return 'Back to Maps';
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('app-header')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/app-header.html
// module id = 623
// module chunks = 0